import { createGlobalStyle } from "styled-components"
import THEME from "../configuration/Theme"

export const buttonColorBlue = "#28c4fc"

export const GlobalStyles = createGlobalStyle`
  html, body {
    margin: 0;
    padding: 0;

  }

  body {
    background-color: ${THEME.colors.background};
    color: ${THEME.colors.text};
  }
`

export default GlobalStyles
